import { memo } from 'react'

import { useNavigate, ParsePathParams } from '@tanstack/react-router'

import { SnackPanelActions, SnackPanelActionsProps, ViewSpace } from '@shared/components/Snackbar'
import { useHotkeys } from '@shared/utils/hooks'
import { SnackPanelActionButtonLink } from 'components/LinkedMUIComponents'
import { audioObjectRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Objects/Object'

type SuccessPanelActionsProps = Record<ParsePathParams<typeof audioObjectRoute.fullPath>, string>

const SuccessPanelActionsRaw = ({
  onClose,
  buttonDefaultProps: _,
  ...routeParams
}: SuccessPanelActionsProps & SnackPanelActionsProps) => {
  const navigate = useNavigate()

  useHotkeys([
    [
      'space',
      () => {
        navigate({ to: audioObjectRoute.to, params: routeParams })
        onClose()
      },
    ],
  ])

  return (
    <SnackPanelActions>
      <SnackPanelActionButtonLink to={audioObjectRoute.to} params={routeParams} onClick={() => onClose()}>
        <ViewSpace />
      </SnackPanelActionButtonLink>
    </SnackPanelActions>
  )
}

export const SuccessPanelActions = memo(SuccessPanelActionsRaw)
